<app-queue
  *ngIf="queue().length"
  #queueComponent
  [queue]="queue()"
  (updateQueue)="handleUpdateQueue($event)"
  (removeBorrower)="handleDeleteBorrowerFromUserQueue($event)"
  (clearQueue)="handleClearUserQueue()"
></app-queue>
